import { NgModule } from '@angular/core';
import { LineChartComponent } from './line-chart.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import {SharedModule} from '../../_shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    ChartsModule,
  ],
  declarations: [LineChartComponent],
  exports: [LineChartComponent]
})
export class LineChartModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/line-chart/line-chart.module.ts